import AlertService from '@/utils/alerts/alert-service';
import AlertPropMixin from './AlertPropMixin';
export default {
	mixins: [AlertPropMixin],
	computed: {
		needAction() {
			return !AlertService.isCompleted(this.alert);
		},
	},
};
